import { ReactElement } from 'react'
import AddIcon from '@mui/icons-material/Add'
import CloseIcon from '@mui/icons-material/Close'
import { Box, IconButton, Stack, Tooltip, Typography } from '@mui/material'
import { AIAccessGrantDTO } from '@api/fastAPI.schemas'
import { formatRemainingTime } from './utils'

interface Props {
  grant: AIAccessGrantDTO
  nowMs: number
  onExtend: (grantId: string) => void
  onRevoke: (grantId: string) => void
  isBusy: boolean
}

const grantLabel = (grant: AIAccessGrantDTO): string => {
  const organisation = grant.organisation_name ?? 'Organisation'
  if (grant.resource_type === 'system_manager') {
    return `Systemmanager (${organisation})`
  }
  if (grant.resource_type === 'new_projects') {
    return `Neue Projekte (${organisation})`
  }
  return grant.project_name ?? grant.project_guid ?? 'Projekt'
}

const GrantRow = ({ grant, nowMs, onExtend, onRevoke, isBusy }: Props): ReactElement => (
  <Stack
    direction="row"
    alignItems="center"
    spacing={1}
    data-cy="ai-access-grant-row"
    sx={{ minWidth: 0 }}
  >
    <Box sx={{ minWidth: 0, flex: 1 }}>
      <Typography variant="body2" noWrap title={grantLabel(grant)}>
        {grantLabel(grant)}
      </Typography>
      {grant.origin === 'auto_created' && (
        <Typography variant="caption" color="text.secondary">
          automatisch — von der KI erstellt
        </Typography>
      )}
    </Box>
    <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>
      {formatRemainingTime(grant.expires_at, nowMs)}
    </Typography>
    <Tooltip title="Um 1 Stunde verlängern">
      <span>
        <IconButton
          size="small"
          onClick={() => onExtend(grant.id)}
          disabled={isBusy}
          data-cy="ai-access-extend-grant"
        >
          <AddIcon fontSize="inherit" />
        </IconButton>
      </span>
    </Tooltip>
    <Tooltip title="Freigabe widerrufen">
      <span>
        <IconButton
          size="small"
          onClick={() => onRevoke(grant.id)}
          disabled={isBusy}
          data-cy="ai-access-revoke-grant"
        >
          <CloseIcon fontSize="inherit" />
        </IconButton>
      </span>
    </Tooltip>
  </Stack>
)

export default GrantRow
